import { IEvents } from "@walletconnect/jsonrpc-types";
export class IClient extends IEvents {
    constructor(opts) {
        super();
        this.protocol = "wc";
        this.version = 2;
    }
}
//# sourceMappingURL=client.js.map